import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function BookingPlatformButton({ ...props }) {
    // If this is a hijacked button, show the hijacked state
    if (props.buttonPlatform === "whatsapp_hijack") {
        return (
            <div className="relative group">
                <div className="relative">
                    <button
                        className={classNames(
                            props.valuePlatform === props.buttonPlatform ? "text-dark-background bg-gray-200 border-yellow-400" : "text-white border-yellow-400 bg-yellow-500",
                            "rounded-t-xl pb-1 pt-2 border-b-4 font-medium flex justify-center items-center uppercase h-8 px-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 hover:scale-110 relative"
                        )}
                        style={{ fontSize: "9px" }}
                        type="button"
                        onClick={() => {
                            props.setFieldValue("platform", props.buttonPlatform);
                            props.setFieldValue("from", props.from);
                            props.setFieldValue("to", props.to);
                        }}
                    >
                        <FontAwesomeIcon className="h-4 w-4 pr-1" aria-hidden="true" icon={props.icon} style={{ color: props.isHijacked ? "#facc15" : "currentColor" }} />
                        <div className="hidden">{props.message}</div>
                    </button>
                    <div className="absolute -top-2 -right-2 w-3 h-3 bg-yellow-400 rounded-full border-2 border-white"></div>
                </div>
                <div className="absolute z-10 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-200 bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap">
                    Hijacked by: {props.hijackedBy}
                    <div className="absolute w-2 h-2 bg-gray-800 transform rotate-45 -bottom-1 left-1/2 -translate-x-1/2"></div>
                </div>
            </div>
        );
    }

    // Normal button state
    return (
        <button
            className={classNames(
                props.valuePlatform === props.buttonPlatform ? "text-dark-background bg-gray-200 border-primary" : "text-white border-primary bg-primary",
                "rounded-t-xl pb-1 pt-2 border-b-4 font-medium flex justify-center items-center uppercase h-8 px-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 hover:scale-110"
            )}
            style={{ fontSize: "9px" }}
            type="button"
            onClick={() => {
                props.setFieldValue("platform", props.buttonPlatform);
                props.setFieldValue("from", props.from);
                props.setFieldValue("to", props.to);
            }}
        >
            <FontAwesomeIcon className="h-4 w-4 pr-1" aria-hidden="true" icon={props.icon} />
            <div className="hidden">{props.message}</div>
        </button>
    );
}
